import React, { useState, useEffect, useRef } from "react";
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaBars,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const solutions = {
  digitalMarketing: [
    {
      name: "Search Engine Optimization (SEO)",
      href: "/digitalMarketing#dmServices1",
    },
    { name: "Content Marketing", href: "/digitalMarketing#dmCards" },
    { name: "Social Media Marketing", href: "/digitalMarketing#localSEO" },
    {
      name: "Affiliate Marketing",
      href: "/digitalMarketing#affiliateMarketing",
    },
    { name: "Mobile Marketing", href: "/digitalMarketing#mobileMarketing" },
  ],
  itServices: [
    { name: "Design & Development", href: "/itServices#services1" },
    { name: "Cloud Computing Services", href: "/itServices#cloudItService" },
    { name: "Software Development", href: "/itServices#softwareDevelopment" },
    { name: "Web Hosting", href: "/itServices#itServicesCards" },
    { name: "Domain Registration", href: "/itServices#itServicesCards" },
  ],
  softwareProducts: [
    {
      name: "Institute Management System (IBS)",
      href: "/softwareProducts#ERP",
    },
    {
      name: "Real Estate Management System (REMS)",
      href: "/softwareProducts#EBS",
    },
    { name: "Hospital Management System (HMS)", href: "/softwareProducts#CRM" },
    {
      name: "Environmental, Social and Governance (ESG)",
      href: "/softwareProducts#IMS",
    },
    { name: "Integrated Business Suite (IBS)", href: "/softwareProducts#IMS" },
    {
      name: "Enterprise Resource Planning (ERP)",
      href: "/softwareProducts#IMS",
    },
  ],
};

const Navbar = () => {
  const [isServicesPopoverOpen, setIsServicesPopoverOpen] = useState(false);
  const [isProductsPopoverOpen, setIsProductsPopoverOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isServicesAccordionOpen, setIsServicesAccordionOpen] = useState(false);
  const [isProductsAccordionOpen, setIsProductsAccordionOpen] = useState(false);
  const servicesRef = useRef(null);
  const productsRef = useRef(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleAccordion = (section) => {
    if (section === "services") {
      setIsServicesAccordionOpen(!isServicesAccordionOpen);
    } else if (section === "products") {
      setIsProductsAccordionOpen(!isProductsAccordionOpen);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setIsServicesPopoverOpen(false);
      }
      if (productsRef.current && !productsRef.current.contains(event.target)) {
        setIsProductsPopoverOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <nav
      className="shadow-md sticky top-0 left-0 z-50 w-full"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(5px)", // Adds a subtle blur effect
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-1">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="cursor-pointer">
              <img
                className="h-10"
                src={require("../assets/images/Logo.png")}
                alt="Logo"
              />
            </Link>
          </div>

          {/* Hamburger Icon */}
          <div className="lg:hidden">
            <button
              onClick={toggleSidebar}
              className="text-[#1e266d] focus:outline-none"
            >
              <FaBars size={24} />
            </button>
          </div>

          {/* Navigation Links */}
          <div className="hidden lg:flex space-x-6 items-center whitespace-nowrap">
            <div className="flex flex-col sm:flex-row lg:flex-row sm:items-center sm:justify-end">
              <Link
                to="/"
                className="text-[#1e266d] font-heading font-semibold px-4 py-2 hover:text-[#1E699F]"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-[#1e266d] font-heading font-semibold px-4 py-2 hover:text-[#1E699F]"
              >
                About
              </Link>

              {/* Services Dropdown */}
              <div
                className="relative group"
                ref={servicesRef}
                onMouseEnter={() => setIsServicesPopoverOpen(true)}
                onMouseLeave={() => setIsServicesPopoverOpen(false)}
              >
                <button className="text-[#1e266d] font-heading font-semibold px-4 py-2 hover:text-[#1E699F]">
                  Services
                </button>
                {isServicesPopoverOpen && (
                  <div className="absolute left-1/2 top-9 z-50 mt-1 w-max max-w-screen-lg -translate-x-1/2">
                    <div
                      className="flex flex-col sm:flex-row p-4 bg-black text-white shadow-lg ring-1 ring-gray-900/5"
                      style={{ backgroundColor: "rgba(12, 12, 12, 0.95)" }}
                    >
                      <div className="p-4 space-y-3">
                        <Link
                          to="/digitalMarketing"
                          className="font-semibold text-lg text-white mb-3 hover:text-[#1E699F]"
                        >
                          DIGITAL MARKETING
                        </Link>
                        {solutions.digitalMarketing.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="block text-md hover:text-[#1E699F]"
                          >
                            {item.name}
                          </Link>
                        ))}
                      </div>
                      <div className="p-4 space-y-3">
                        <Link
                          to="/itServices"
                          className="font-semibold text-lg text-white mb-3 hover:text-[#1E699F]"
                        >
                          IT SERVICES
                        </Link>
                        {solutions.itServices.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="block text-md hover:text-[#1E699F]"
                          >
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Products Dropdown */}
              <div
                className="relative group flex-grow flex-shrink-0 h-12 flex items-center justify-center mx-2"
                ref={productsRef}
                onMouseEnter={() => setIsProductsPopoverOpen(true)}
                onMouseLeave={() => setIsProductsPopoverOpen(false)}
              >
                <button className="inline-flex items-center gap-x-1 text-[#1e266d] font-heading font-semibold relative hover:text-[#1E699F]">
                  <Link to="/softwareProducts">Products</Link>
                </button>
                <span className="absolute bottom-0 left-0 w-full h-1 bg-[#1E699F] transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>

                {/* {isProductsPopoverOpen && (
                  <div className="absolute left-1/2 top-9 z-50 mt-1 w-max max-w-screen-lg -translate-x-1/2">
                    <div
                      className="flex w-max max-w-screen-lg overflow-hidden text-sm leading-6 shadow-lg ring-1 ring-gray-900/5"
                      style={{
                        backgroundColor: "rgba(12, 12, 12, 0.95)",
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
                      }}
                    >
                      <div className="p-4 flex-1">
                        <p className="font-semibold text-lg text-white mb-3">
                          SOFTWARE PRODUCTS
                        </p>
                        {solutions.softwareProducts.map((item) => (
                          <div
                            key={item.name}
                            className="group h-auto relative flex gap-x-6 rounded-lg p-2"
                          >
                            <Link
                              to={item.href}
                              className="text-white text-md hover:text-[#1E699F] whitespace-nowrap"
                            >
                              {item.name}
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )} */}
              </div>

              <Link
                to="/ourAffiliations"
                className="text-[#1e266d] font-heading font-semibold px-4 py-2 hover:text-[#1E699F]"
              >
                Our Affiliations
              </Link>

              <Link
                to="/contact"
                className="text-[#1e266d] font-heading font-semibold px-4 py-2 hover:text-[#1E699F]"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Social Media Icons */}
          <div className="hidden lg:flex space-x-4">
            <Link
              to="https://www.facebook.com/Scitforte"
              target="_blank"
              rel="noopener noreferrer"
              className="pl-2 text-[#1e266d]"
            >
              <FaFacebook
                size={20}
                className="hover:text-[#1E699F] transition duration-300"
              />
            </Link>
            <Link
              to="https://www.linkedin.com/company/scitforte/mycompany/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#1e266d]"
            >
              <FaLinkedin
                size={20}
                className="hover:text-[#1E699F] transition duration-300"
              />
            </Link>
            <Link
              to="https://www.instagram.com/scitforte?igsh=Zmp3aW5yaDQxaG05"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram
                size={20}
                className="text-pink-600 hover:text-pink-800 transition duration-300"
              />
            </Link>
          </div>

          {/* Sidebar for Mobile */}
          {isSidebarOpen && (
            <div className="lg:hidden fixed inset-0 z-50 bg-black bg-opacity-50">
              <div className="w-2/3 max-w-md p-4 h-svh bg-gradient-to-b from-gray-100 via-slate-200 to-gray-300">
                <div className="flex justify-between items-center mb-10">
                  <div className="flex-shrink-0">
                    <img
                      className="h-10"
                      src={require("../assets/images/Logo.png")}
                      alt="Logo"
                    />
                  </div>
                  <button
                    onClick={toggleSidebar}
                    className="text-[#1e266d] focus:outline-none flex"
                  >
                    <FaTimes size={24} />
                  </button>
                </div>
                <nav className="space-y-4 flex flex-col justify-start items-start px-2">
                  <Link
                    to="/"
                    className="block text-[#1e266d] font-heading font-semibold hover:text-[#1E699F]"
                    onClick={toggleSidebar}
                  >
                    Home
                  </Link>
                  <div className="w-full h-[1px] bg-black" />
                  <Link
                    to="/about"
                    className="block text-[#1e266d] font-heading font-semibold hover:text-[#1E699F]"
                    onClick={toggleSidebar}
                  >
                    About
                  </Link>
                  <div className="w-full h-[1px] bg-black" />
                  {/* Services Accordion */}
                  <div className="w-full">
                    <button
                      onClick={() => toggleAccordion("services")}
                      className="flex justify-between items-center gap-1 w-full text-[#1e266d] font-heading font-semibold hover:text-[#1E699F]"
                    >
                      <span>Services</span>
                      {isServicesAccordionOpen ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </button>
                    {isServicesAccordionOpen && (
                      <div className="pl-4 mt-2 space-y-3">
                        <Link
                          to="/digitalMarketing"
                          className="block font-bold underline text-[#1e266d] hover:text-[#1E699F]"
                          onClick={toggleSidebar}
                        >
                          Digital Marketing
                        </Link>
                        {solutions.digitalMarketing.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="block text-sm font-medium text-[#1e266d] hover:text-[#1E699F]"
                            onClick={toggleSidebar}
                          >
                            {item.name}
                          </Link>
                        ))}
                        <Link
                          to="/itServices"
                          className="block font-bold underline text-[#1e266d] hover:text-[#1E699F]"
                          onClick={toggleSidebar}
                        >
                          IT Services
                        </Link>
                        {solutions.itServices.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="block text-sm font-medium text-[#1e266d] hover:text-[#1E699F]"
                            onClick={toggleSidebar}
                          >
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="w-full h-[1px] bg-black" />
                  {/* Products Accordion */}
                  <Link
                    to="/softwareProducts"
                    className="block text-[#1e266d] font-heading font-semibold hover:text-[#1E699F]"
                  >
                    Products
                  </Link>
                  <div className="w-full h-[1px] bg-black" />
                  <Link
                    to="/ourAffiliations"
                    className="block text-[#1e266d] font-heading font-semibold hover:text-[#1E699F]"
                  >
                    Our Affiliations
                  </Link>
                  <div className="w-full h-[1px] bg-black" />
                  <Link
                    to="/contact"
                    className="block text-[#1e266d] font-heading font-semibold hover:text-[#1E699F]"
                    onClick={toggleSidebar}
                  >
                    Contact Us
                  </Link>
                  <div className="w-full h-[1px] bg-black" />
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
